<template>
  <section class="us__section">
    <form-headers></form-headers>
    <section class="form__section">
      <div class="form__section-image">
        <img src="@/assets/img/illust5.png" alt="illustration 5" />
      </div>
      <div class="lds-ring" v-if="sending">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="form" :class="{ loading: sending }">
        <div class="form__sections">
          <formSection @readyToSubmit="readyToSubmit($event)"></formSection>
        </div>
        <div class="form__privacy">
          <p class="form__privacy-text">
            TeqVibe requires the information requested on this form in order to
            contact you regarding our services only. For our practices and
            commitment to protecting your privacy, review our
            <a href="/privacy" class="form__privacy-link" target="_blank"
              >privacy policy</a
            >.
          </p>
        </div>
        <div class="form__submit">
          <button
            type="button"
            class="btn btn--submit"
            :class="{ 'btn--unavailable': !submit }"
            @click="submitForm"
          >
            Submit
            <span v-if="status === 'success'">
              {{ status === 'success' ? 'Successful' : 'Failed' }}
            </span>
          </button>
        </div>
      </div>
    </section>
    <tq-footer></tq-footer>
  </section>
</template>

<script>
import formSection from '../Form/Form';
import formHeaders from '../FormSection/FormHeaders';
import tqFooter from '../Footer';

export default {
  data() {
    return {
      submit: false,
      data: null,
      sending: false,
      status: null
    };
  },
  components: {
    formSection,
    formHeaders,
    tqFooter
  },
  methods: {
    submitForm() {
      if (this.submit === false) {
        return;
      }
      this.sending = true;
      this.$store.dispatch('SEND_EMAIL', this.data).then(res => {
        this.status = res.data.status;
        this.sending = false;
        if (this.status === 'success') {
          document
            .querySelectorAll('.form__input')
            .forEach(v => (v.value = ''));
          document
            .querySelectorAll('.form__group')
            .forEach(v => v.classList.remove('form__group--success'));
          document
            .querySelectorAll('.radio__inputs')
            .forEach(v => v.removeAttribute('checked'));
          document
            .querySelectorAll('.radio__group')
            .forEach(v => (v.style.border = '1px solid #d8d8d8'));
          document.querySelector('.radio__inputs').click();
          setTimeout(() => (this.status = null), 3000);
          this.submit = false;
        }
      });
    },
    readyToSubmit(params) {
      if (params === false) {
        this.submit = false;
        return;
      }
      this.submit = true;
      this.data = {
        project_type: document.querySelector(
          '.radio__inputs[name=radio-input]:checked'
        ).value,
        name: params.name.$model,
        last_name: params.last_name.$model,
        email: params.email.$model,
        phone: params.phone.$model,
        company: params.company.$model,
        employees: params.employees.$model,
        comment: params.comment.$model
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.us__section {
  width: 100%;
  position: relative;
}
.form__section {
  padding-left: 6%;
  padding-right: 6%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 12rem;
  background-image: linear-gradient(
      to bottom,
      rgba($text-light-gray, 0.1) 0%,
      rgba($text-gray, 0.1) 50%
    ),
    url(../../assets/img/bg4.jpg);
  padding-bottom: 15rem;
  &-image {
    width: 50%;
    position: relative;
    img {
      width: 80%;
    }
    @include mq-max(991px) {
      width: 40rem;
    }
    @include mq-max(450px) {
      width: 100%;
    }
  }
  @include mq-max(991px) {
    flex-direction: column-reverse;
    margin-top: 0;
    img {
      width: 100%;
      margin: 5rem 0;
    }
  }
}
.form {
  max-width: 52rem;
  padding: 2.4rem;
  position: relative;
  border-radius: 2rem;
  height: 60rem;
  background-color: $white;
  @include mq-max(991px) {
    height: unset;
    margin-top: 12rem;
  }
  @include mq-max(450px) {
    max-width: 100%;
    margin-top: 10rem;
  }
  &:before {
    content: 'Get in touch';
    color: $white;
    position: absolute;
    left: -30%;
    top: 20%;
    transform: rotate(-90deg);
    font-family: Roboto;
    font-size: 6.4rem;
    font-weight: bold;
    letter-spacing: -0.6rem;
    line-height: 7.5rem;
    text-align: right;
    @include mq-max(991px) {
      transform: unset;
      left: 5%;
      top: -5.5%;
    }
    @include mq-max(450px) {
      left: 0;
      top: -5%;
      font-size: 5.4rem;
    }
  }
  &__sections {
    display: flex;
  }
  &__privacy {
    margin-top: 2.8rem;
    &-link {
      border-bottom: 1px solid $text-gray;
    }
    &-text {
      color: $text-gray;
      font-family: Roboto;
      font-size: 1.4rem;
      font-weight: 300;
      letter-spacing: 0;
      line-height: 1.6rem;
    }
  }

  &__submit {
    float: right;
    margin-top: 2.5rem;
    min-width: 24rem;
    .btn {
      cursor: pointer;
      border-radius: 0.8rem;
      background-color: #ffffff;
      box-shadow: 0 1.6rem 5.6rem 0 rgba(0, 0, 0, 0.1);
      width: 100%;
      outline: none;
      &--unavailable {
        cursor: not-allowed;
        background-image: linear-gradient(
          to right,
          $text-light-gray,
          $text-gray
        );
      }
    }
  }
}
</style>
